import { z } from 'zod';
/** Path parameters `POST /flow-definitions/{flowDefinitionId}/cost-estimate` accepts. */
export const FlowDefinitionCostEstimateParamsSchema = z.strictObject({
    flowDefinitionId: z.uuid().describe('The flow definition to estimate.'),
});
/**
 * Body `POST /flow-definitions/{flowDefinitionId}/cost-estimate` accepts.
 *
 * An override replaces the quantity the estimate would otherwise derive for one action unit of one
 * block, which is how a caller prices a volume the definition itself does not state.
 */
export const FlowDefinitionCostEstimateBodySchema = z.strictObject({
    quantityOverrideLineItems: z
        .array(z.object({
        blockId: z.uuid(),
        actionUnitName: z.string(),
        quantity: z.number(),
    }))
        .optional(),
});
//# sourceMappingURL=costEstimateRequest.js.map